module.exports = __webpack_public_path__ + "res/img/icon-changeCamera.4fe252cb.png";